module.exports = __webpack_public_path__ + "img/Close.5307edf0.svg";